import React, { useState } from 'react';
import { SvgIcon, Button, Collapse } from '@mui/material';
import { SmokingRooms as SmokingRoomsIcon } from '@mui/icons-material';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import UserIcon from '../../../../icons/user.svg?react';
import PinLocationIcon from '../../../../icons/pin-location.svg?react';
import CalendarIcon from '../../../../icons/calendar1.svg?react';
import NoSmokeIcon from '../../../../icons/no-smoke.svg?react';
import HeightIcon from '../../../../icons/height.svg?react';
import ScaleIcon from '../../../../icons/scale.svg?react';
import IsJuvenile from '../../../Helpers/Dates/IsJuvenile';
import Age from '../../../Helpers/Dates/Age';
import TobaccoUsage from '../Helpers/TobaccoUsage';
import ConvertToShortHandHeight from '../../../Helpers/Formatters/ShortHandHeight';
import { isValidHeight, isValidWeight } from '../../../Common/CheckValidHeightOrWeight';
import './BasicInfoSummary.scss';

export function BasicInfoSummary(props) {
  const isJuvenile = props.birthdate && IsJuvenile(props.birthdate) && props.isJuvenileApp === true;
  const age = props.birthdate ? Age(props.birthdate) : null;
  const smoker = TobaccoUsage(props.tobacco) === 'true' ? true : TobaccoUsage(props.tobacco) === 'false' ? false : null;

  const height = isValidHeight(props.height) ? ConvertToShortHandHeight(props.height) : props.showDash ? '-' : null;
  const weight = isValidWeight(props.weight) ? (props.weight.includes('pounds') ? props.weight.replace('pounds', 'lbs').replace(' ', '') : props.weight) : props.showDash ? '-' : null;

  const data = [
    {
      icon: UserIcon,
      label: 'Gender',
      text: props.gender === 'F' ? 'Female' : props.gender === 'M' ? 'Male' : null
    },
    {
      icon: CalendarIcon,
      label: 'Age',
      text: age
    },
    {
      icon: PinLocationIcon,
      label: 'State',
      text: props.state
    },
    {
      icon: HeightIcon,
      label: 'Height',
      text: height,
      hideMobile: true
    },
    {
      icon: ScaleIcon,
      label: 'Weight',
      text: weight,
      hideMobile: true
    },
    {
      skip: isJuvenile,
      icon: smoker ? SmokingRoomsIcon : NoSmokeIcon,
      label: 'Smoker',
      text: smoker === null ? null : smoker ? 'Yes' : 'No'
    }
  ];
  return (
    <div className="basic-info-summary d-flex flex-wrap justify-content-center py-2">
      {data.map((d, index) => d.text &&
        <Col key={index} className={`${props.isRow ? "flex-row" : "flex-column"} px-1 ${d.skip ? 'd-none' : 'd-flex'} ${d.hideMobile ? "hide-mobile" : ""}`}>
          <SvgIcon role="img" component={d.icon} color="primary" className="mx-auto" aria-hidden={false}
                   aria-label={d.label} id={`${d.label}-${index}`}/>
          <div className={`mx-auto summary-text primary-color`}>{d.text}</div>
        </Col>
      )
      }
    </div>
  );
}

export function CollapsibleBasicInfoSummary(props) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="collapsible-basic-info-summary">
      <Row>
        <Col>
          <Button variant="text" color='inherit' className="expand" onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
            Summary
          </Button>
        </Col>
        <Col xs="auto">
          <Button variant="text" className={`edit primary-color`} onClick={props.editLinkOnClick}>Edit</Button>
        </Col>
      </Row>
      <div>
        <Collapse in={expanded} className="w-100">
          <BasicInfoSummary {...props} />
        </Collapse>
      </div>
    </div>
  );
}

export function EditableBasicInfoSummary(props) {
  return (
    <div className="editable-basic-info-summary">
      <div>
          <BasicInfoSummary isRow={true} {...props} />
          <Button variant="text" className={`edit primary-color`} onClick={props.editLinkOnClick}>Edit</Button>
      </div>
    </div>
  );
}

BasicInfoSummary.propTypes = {
  gender: PropTypes.string,
  state: PropTypes.string,
  birthdate: PropTypes.string.isRequired,
  tobacco: PropTypes.string,
  height: PropTypes.string,
  weight: PropTypes.string,
  showDash: PropTypes.bool,
  isRow: PropTypes.bool,
  isJuvenileApp: PropTypes.bool,
};

CollapsibleBasicInfoSummary.propTypes = {
  gender: PropTypes.string,
  state: PropTypes.string,
  birthdate: PropTypes.string.isRequired,
  tobacco: PropTypes.string,
  height: PropTypes.string,
  weight: PropTypes.string,
  editLinkOnClick: PropTypes.func,
};

EditableBasicInfoSummary.propTypes = {
  gender: PropTypes.string,
  state: PropTypes.string,
  birthdate: PropTypes.string.isRequired,
  tobacco: PropTypes.string,
  height: PropTypes.string,
  weight: PropTypes.string,
  editLinkOnClick: PropTypes.func,
};
